export default __webpack_public_path__ + "static/proxima-nova-100-i-c6b7a57ec42a29eb1f7aab085ac11a04.woff2";